import { ActionReducerMap } from '@ngrx/store';

import { FormLoadState } from '../../../store/shared/dcr-form-submission/form-submission.type';
import { AppState } from '../../../store/shared/types/app-state.type';
import {
  ContactUsActionsUnion,
  ContactUsActionTypes,
} from './contact-us.actions';
import { ContactUsState } from './types/contact-us.state.type';

export const initialContactUsState: ContactUsState = {
  requestPayload: {
    formId_: 'Contact Us',
    fullName: '',
    emailAddress: '',
    topic_: '',
    comments: '',
    confirmationCode: '',
    travelingWithin48Hours: '',
    language: '',
  },
  loadState: FormLoadState.Idle,
};

export function contactUsReducer(
  state = initialContactUsState,
  action: ContactUsActionsUnion,
): ContactUsState {
  switch (action.type) {
    case ContactUsActionTypes.CONTACT_US_SUBMIT_REQUESTED:
      return {
        ...state,
        loadState: FormLoadState.Submitting,
        requestPayload: action.payload,
      };

    case ContactUsActionTypes.CONTACT_US_SUBMIT_SUCCEEDED:
      return {
        ...state,
        loadState: FormLoadState.Success,
      };

    case ContactUsActionTypes.CONTACT_US_SUBMIT_FAILED:
      return {
        ...state,
        loadState: FormLoadState.Failure,
      };

    default:
      return state;
  }
}

export const featureKey = 'contactUsForm';

export const featureReducer: ActionReducerMap<AppState> = {
  contactUsForm: contactUsReducer,
};
